var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
export class PeriodField {
  constructor(_data) {
    /**
     */
    __publicField(this, "Field");
    /**
     */
    __publicField(this, "Order");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof PeriodField
     */
    __publicField(this, "$type", "V1.Cesop.Periods.Search.PeriodField");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.Field = PeriodFieldField[_data["Field"]];
      this.Order = PeriodFieldOrder[_data["Order"]];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["Field"] = PeriodFieldField[this.Field];
    _data["Order"] = PeriodFieldOrder[this.Order];
    return _data;
  }
}
export var PeriodFieldField = /* @__PURE__ */ ((PeriodFieldField2) => {
  PeriodFieldField2["PspName"] = "PspName";
  PeriodFieldField2["StartDate"] = "StartDate";
  PeriodFieldField2["ReportingCountry"] = "ReportingCountry";
  PeriodFieldField2["Status"] = "Status";
  PeriodFieldField2["RegistrationIdentifier"] = "RegistrationIdentifier";
  PeriodFieldField2["Version"] = "Version";
  return PeriodFieldField2;
})(PeriodFieldField || {});
export var PeriodFieldOrder = /* @__PURE__ */ ((PeriodFieldOrder2) => {
  PeriodFieldOrder2["Ascending"] = "Ascending";
  PeriodFieldOrder2["Descending"] = "Descending";
  return PeriodFieldOrder2;
})(PeriodFieldOrder || {});
